/**
 * Normalize API / axios errors into a user-facing string.
 * Handles FastAPI `detail`, Nexus `context.message`, and plain `message`.
 */
export const extractDataTransferError = (
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string => {
  const data = (error as any)?.response?.data;

  const detail = data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail.trim();
  if (Array.isArray(detail)) {
    const joined = detail
      .map((item: any) =>
        typeof item === "string"
          ? item
          : item?.msg ?? item?.message ?? JSON.stringify(item),
      )
      .filter(Boolean)
      .join("; ");
    if (joined) return joined;
  }

  const contextMessage = data?.context?.message;
  if (typeof contextMessage === "string" && contextMessage.trim()) {
    return contextMessage.trim();
  }

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message.trim();
  }

  const axiosMessage = (error as any)?.message;
  if (typeof axiosMessage === "string" && axiosMessage.trim()) {
    return axiosMessage.trim();
  }

  return fallback;
};
